import React, { forwardRef } from 'react';

export const normalizeCellEditor = WrappedComponent => {
    const Hoc = forwardRef((props, _) => {
        const { onValueChange, stopEditing } = props;

        const handleSave = newValue => {
            onValueChange(newValue);
            stopEditing();
        };

        return <WrappedComponent {...props} onSave={handleSave} onCancel={stopEditing} />;
    });

    return Hoc;
};
